import dynamic from 'next/dynamic';

const ContactForm = dynamic(
  () => import(/* webpackChunkName: "pbKpContactForm" */ '../../../../components/ContactForm')
);

const pageBuilderComponents = {
  'kp-form': ContactForm
};

export default pageBuilderComponents;
